
import styled from 'styled-components'

const Tabs = styled.div<{
    readonly activable: boolean,
}>`
    display: flex;
    pointer-events: ${props => props.activable ? 'auto' : 'none'};
    position: relative;
    z-index: 1;

    &.long {
        display: none;
    }

    &.short {
        display: flex;
    }

    @media (min-width: 961px) {
        &.long {
            display: flex;
        }

        &.short {
            display: none;
        }
    }
`

export default Tabs